// extracted by mini-css-extract-plugin
export default {"notificationCount":"DueChildLifeSkillIcon_notificationCount__De0-D"};